import React, { Component } from 'react';
import { observer } from "mobx-react";

class User extends Component {
    
    render() {
        return (
            <p className="me">
                {this.props.message || '...'} <br />
                <div className="minutes">{this.props.time}</div>
                <div className="icon-user"></div>
            </p>
        )
    }
}

export default observer(User);
//                <i className="material-icons">person</i>
